import { render, staticRenderFns } from "./OrderVpnCode.vue?vue&type=template&id=5d0ee4d2&scoped=true&"
import script from "./OrderVpnCode.vue?vue&type=script&lang=js&"
export * from "./OrderVpnCode.vue?vue&type=script&lang=js&"
import style0 from "./OrderVpnCode.vue?vue&type=style&index=0&id=5d0ee4d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0ee4d2",
  null
  
)

export default component.exports